/** module import */
import axios from 'axios'
// import queryString from 'query-string'
import * as Define from '@common/Define'

export function reSetToken() {
  // const refreshToken = window.sessionStorage.getItem('refreshToken')

  const res = axios.post(Define.CH_USER_API.SIGN_IN + '/admin-users/refresh', {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
      'Access-Control-Allow-Headers': 'Content-Type',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': '*',
    },
    // },{ withCreadentials: true });
  })
  res.then((response) => {
    console.log(response.data)
    window.sessionStorage.setItem('authToken', response.data.access_token)
    window.location.reload()
  })
}

class _CustomAxiosModule {
  constructor(url, token = '') {
    // with credential
    this.AXIOS = axios.create({
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Headers': 'Content-Type',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': '*',
      },
      withCredentials: false,
      timeout: 15000,
    })
    this.AXIOS.defaults.headers.common.Authorization = `Bearer ${token}`
    this.AXIOS.defaults.baseURL = `${url}/`
    this.AXIOS.interceptors.response.use(
      (response) => {
        // 성공 시
        return Promise.resolve(response)
      },
      (error) => {
        // 실패 시
        if (error.response.status === 401) {
          console.log('http 401 error')
          // reSetToken()
        }
        if (error.response.status === 404) {
          console.log('http 404 error')
        }
        if (error.response.status === 406) {
          console.log('http 406 error')
        }
        if (error.response.status === 500) {
          console.log('http 500 error')
        }
        return Promise.reject(error)
      },
    )
  }

  get(url, params) {
    /** 수정 */
    return this.AXIOS && this.AXIOS.get(url, params)
  }

  post(url, params) {
    return this.AXIOS && this.AXIOS.post(url, params)
  }

  patch(url, params) {
    return this.AXIOS && this.AXIOS.patch(url, params)
  }

  put(url, params) {
    return this.AXIOS && this.AXIOS.put(url, params)
  }

  delete(url, params) {
    return this.AXIOS && this.AXIOS.delete(url, { data: params })
  }
}

export default _CustomAxiosModule
